import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./css/solutions.css";
import glassHero from "./img/Glass1.webp"; // 確保圖片存在，必要時替換檔名

const ensureGlassI18n = (i18n) => {
  const ns = "glass";
  if (!i18n.hasResourceBundle("en", ns)) {
    i18n.addResourceBundle("en", ns, {
      sectionTitle: "Glass",
      sectionSubtitle: "Vision Inspection for Continuous Glass Surface Quality",
      title: "GLASS",
      heroDesc:
        "Wintriss vision inspection systems detect continuous running glass surface defects 100% online or offline, and accurately provide product quality information.",
      typicalProductsTitle: "Typical Products",
      typicalProductsContent:
        "Float glass, sheet glass, automotive glass, architectural glass, display glass, sputtered glass, patterned glass.",
      typicalDefectsTitle: "Typical Defects",
      typicalDefectsContent:
        "Dirt, bubbles, digs, knots, lines, crush, cords, inclusions."
    });
  }
  if (!i18n.hasResourceBundle("zh", ns)) {
    i18n.addResourceBundle("zh", ns, {
      sectionTitle: "玻璃",
      sectionSubtitle: "連續玻璃表面品質視覺檢測",
      title: "玻璃",
      heroDesc:
        "微覺視視覺檢測系統可於線上或離線 100% 偵測連續運行玻璃表面缺陷，並精準提供產品品質資訊。",
      typicalProductsTitle: "典型產品",
      typicalProductsContent:
        "浮法玻璃、平板玻璃、車用玻璃、建築玻璃、顯示玻璃、濺鍍玻璃、壓花玻璃。",
      typicalDefectsTitle: "常見缺陷",
      typicalDefectsContent:
        "灰塵、氣泡、挖痕、結節、條紋、破碎痕、絲紋、內含物。"
    });
  }
};

function Glass() {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    ensureGlassI18n(i18n);
  }, [i18n]);

  return (
    <div>
      <section className="section-glass relative bg-gray-900 text-white">
        <div className="absolute inset-0 bg-black bg-opacity-70" />
        <div className="container mx-auto px-4 relative z-10">
          <h1 className="text-5xl font-bold mb-4">{t("glass:sectionTitle")}</h1>
          <p className="text-xl text-white">{t("glass:sectionSubtitle")}</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <h2 className="text-3xl font-bold mb-4 tracking-wide">
            {t("glass:title")}
          </h2>
          <p className="leading-relaxed text-sm md:text-base">
            {t("glass:heroDesc")}
          </p>
        </div>
        <div className="flex justify-center">
          <img
            src={glassHero}
            alt={t("glass:title")}
            className="rounded-lg shadow-lg w-full max-w-md object-cover"
            loading="lazy"
          />
        </div>
      </div>

      <section className="max-w-7xl mx-auto px-6 pb-12">
        <div className="bg-white border rounded-lg p-6 shadow-sm">
          <h3 className="text-lg font-semibold mb-3">
            {t("glass:typicalProductsTitle")}
          </h3>
          <p className="text-sm text-gray-700 leading-relaxed">
            {t("glass:typicalProductsContent")}
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 pb-24 grid md:grid-cols-2 gap-6">
        <div className="bg-white border rounded-lg p-5 shadow-sm">
          <h3 className="text-lg font-semibold mb-3">
            {t("glass:typicalDefectsTitle")}
          </h3>
          <p className="text-sm text-gray-700 leading-relaxed">
            {t("glass:typicalDefectsContent")}
          </p>
        </div>
      </section>
    </div>
  );
}

export default Glass;